// Fixed industry list (spec: "Industry from a fixed list").
export const INDUSTRIES = [
  'Technology / IT',
  'Financial Services',
  'Healthcare',
  'Government / Public Sector',
  'Education',
  'Manufacturing',
  'Retail / Consumer',
  'Construction',
  'Professional Services',
  'Media / Marketing',
  'Telecommunications',
  'Energy / Utilities',
  'Transport / Logistics',
  'Hospitality / Tourism',
  'Real Estate / Property',
  'Legal',
  'Non-profit',
  'Other',
];
